import React, { useState, useEffect, useCallback } from "react";
import "./OurServices.css";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://ikaze-thouse-backend.vercel.app";

export default function Home() {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const [items, setItems] = useState([]);
  const [activeBookings, setActiveBookings] = useState([]); // Stores cleaned names of unavailable units
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const nextSlide = useCallback(() => {
    setCurrent((prev) =>
      prev === slides.length - 1 ? 0 : prev + 1
    );
  }, [slides.length]);

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  // ✅ Clean text strings to prevent whitespace or hyphen mismatch bugs
  const cleanUnitString = (str) => {
    if (!str) return "";
    return str.toString().toLowerCase().replace(/[\s\-_]/g, "").trim();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [sRes, iRes, bRes] = await Promise.all([
          fetch(`${BASE_URL}/api/slides/all`),
          fetch(`${BASE_URL}/api/items`),
          fetch(`${BASE_URL}/api/v1/bookings`).catch(() => null)
        ]);

        const slidesData = await sRes.json();
        const itemsData = await iRes.json();
        
        setSlides(slidesData);
        setItems(itemsData);

        if (bRes) {
          const bookingsData = await bRes.json();
          
          console.log("RAW BACKEND BOOKINGS DATA:", bookingsData);

          const reservedUnits = [];
          const actualBookingsArray = Array.isArray(bookingsData) 
            ? bookingsData 
            : (bookingsData?.bookings || []);

          actualBookingsArray.forEach(booking => {
            if (!booking) return;

            // Normalize status to lowercase
            const rawStatus = booking.status || "";
            const status = rawStatus.toString().toLowerCase().trim();

            // Read the correct database column name: appartment_unit
            const unitNameField = booking.appartment_unit || booking.apartment_unit || "";

            // ✅ Lock out anything that isn't explicitly rejected/reject
            if (status !== "" && status !== "rejected" && status !== "reject") {
              if (unitNameField) {
                // Store the completely cleaned variation (e.g. "akezaa1")
                reservedUnits.push(cleanUnitString(unitNameField));
              }
            }
          });
          
          console.log("MATCHED RESERVED UNITS LIST (CLEANED):", reservedUnits);
          setActiveBookings(reservedUnits);
        }

      } catch (e) {
        console.error("Fetch error:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (slides.length > 0) {
      const itv = setInterval(nextSlide, 5000);
      return () => clearInterval(itv);
    }
  }, [nextSlide, slides.length]);

  const getImg = (url) =>
    url?.startsWith("http")
      ? url
      : `${BASE_URL}${url}`;

  if (loading) {
    return (
      <div className="loader">
        <span></span>
      </div>
    );
  }

  return (
    <div className="home-page">

      <section className="hero-viewport">
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`hero-item ${i === current ? "active" : ""}`}
          >
            <div
              className="hero-bg"
              style={{
                backgroundImage: `url(${getImg(slide.image_url)})`
              }}
            />

            <div className="hero-overlay"></div>

            <div className="hero-text-box">
              <span className="hero-subtitle">
                Premium Selection
              </span>

              <h1>{slide.title}</h1>
              <p>{slide.description}</p>

              <button className="gold-btn">
                Discover Collection
              </button>
            </div>
          </div>
        ))}

        <div className="slider-nav">
          <button onClick={prevSlide} className="nav-arrow">
            Prev
          </button>

          <div className="nav-dots">
            {slides.map((_, i) => (
              <span
                key={i}
                className={`nav-dot ${i === current ? "active" : ""}`}
                onClick={() => setCurrent(i)}
              />
            ))}
          </div>

          <button onClick={nextSlide} className="nav-arrow">
            Next
          </button>
        </div>
      </section>

      {/* COLLECTION */}
      <section className="catalog-section">

        <div className="catalog-grid">

          {items.map((item) => {
            // ✅ Clean current UI loop item string for checking array matching rules
            const currentItemUnitCleaned = cleanUnitString(item.unitname);
            const isReserved = activeBookings.includes(currentItemUnitCleaned);

            return (
              <div key={item.id} className="catalog-card">

                <div className="card-media">
                  <img
                    src={getImg(item.image_url)}
                    alt={item.description}
                  />
                </div>

                <div className="card-content">

                  <h3>{item.description}</h3>

                  <span>{item.price}</span>

                  <span>{item.unitname}</span>

                  <button
                    className={`book-btn ${isReserved ? "disabled-btn" : ""}`}
                    disabled={isReserved}
                    style={isReserved ? { 
                      backgroundColor: '#cccccc', 
                      color: '#666666', 
                      cursor: 'not-allowed',
                      pointerEvents: 'none' // 🛑 Guarantees user cannot trigger element clicks manually
                    } : {}}
                    onClick={() => {
                      if (isReserved) return;
                      navigate("/Booking", {
                        state: {
                          unitname: item.unitname,
                          price: item.price
                        }
                      });
                    }}
                  >
                    {isReserved ? "Reserved" : "Book Now"}
                  </button>

                </div>

              </div>
            );
          })}
        </div>
      </section>

    </div>
  );
}